import React, { Component } from 'react';
import ReactTable from "react-table-6"
import "react-table-6/react-table.css";
import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";
import { DialogComponent } from '@syncfusion/ej2-react-popups';


class PreEscalationMsgReact extends Component {
  constructor() {
    super();

    this.dialogClose = () => {
      this.setState({ hideDeletePopup: false, });
    };

    this.settings = { effect: 'Zoom', duration: 400, delay: 0 };

    //for delete dialog component ok click
    this.buttons = [{
      buttonModel: {
        content: 'Yes',
        cssClass: 'e-flat',
        isPrimary: true,

      },
      'click': props => {
        this.deletePreEscMsgApi(this.state.propsId)
        this.setState({ disabled: false })

      }
    }
      , {
      buttonModel: {
        content: 'No',
        cssClass: 'e-flat',
        isPrimary: true,
      },
      'click': () => {
        this.setState({
          hideDeletePopup: false,
          disabled: false
        });
      }
    }];


    this.state = {
      data: [{
        id: '',
        message: '',
        language: [],
        autoTranslate: '',
        deleteRow: false,
      }],
      pageNum: null,
      disabled: false,
      editedId: '-1',
      editImageSrc: './assets/images/edit2.png',
      contentEditable: "false",
      showStore: false,
      hidden: false,
      hideAddDialog: false,
      hideupdateDialog: false,
      hideDeletePopup: false,
      hideDeleteSuccessPopup: false
    }
    this.editImageSrc = "./assets/images/edit2.png";
    this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
    this.language = [];
  }


  addRow = (data) => {
    var preController = this;
    if (preController.state.pageNum != 0) {
      preController.setState({ pageNum: 0 })
    }
    this.state.data.unshift({
      id: '',
      message: '',
      autoTranslate: ''
    });
    this.setState({
      data: this.state.data,
      disabled: true
    })
  }

  notifyFailToLoad() {
    toast.dismiss();
    toast(<b style={{ color: "red" }}>Oops! Error occurred.Please try again</b>, {
      position: "top-center",
      color: "red"
    });
  }

  savePreEscalationMsgApi(props, e) {
    this.state.data[props.index].message = document.getElementById("message" + props.index).innerText.trim();
    this.state.data[props.index].autoTranslate = document.getElementById("autoTranslate" + props.index).checked;
    this.state.editedId = "-1";
    this.setState(this.state);

    var validateResult = this.validateCells(props.original.message, props.original.language,
      props.original.autoTranslate);

    if (validateResult == true) {
      var addedData = {
        message: this.state.data[props.index].message,
        language: document.getElementById('selectTriggerlanguage').value,
        autoTranslate: this.state.data[props.index].autoTranslate,
        projectId: localStorage.getItem("currentProjectId"),
        language: document.getElementById('selectTriggerlanguage').value,
      };

      var addPreEscMsgController = this;
      $.ajax({
        url: "/api/pre-escalation-msg",
        async: false,
        method: 'POST',
        headers: {
          'Authorization': "Bearer " + localStorage.getItem("access_token"),
          'Content-Type': 'application/json',
        },
        data: JSON.stringify(addedData),
        processData: false,
        contentType: "application/json; charset=UTF-8",
        success: function (res) {
          if (res.success === true) {
            addPreEscMsgController.notifyAdd();
            addPreEscMsgController.fetchPreEscMsgDataApi();
            addPreEscMsgController.state.disabled = false;
          } else {
            addPreEscMsgController.notifyFailToAdd(res.result);
            addPreEscMsgController.state.disabled = false;
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "/";
          }
        }

      })
    }
  }

  notifyAdd() {
    toast.dismiss();
    toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Missed-Query Responses Added Successfully</b>, {
      position: "top-center",

    });
  }

  notifyFailToAdd(response) {
    toast.dismiss();
    toast(<b>{response}</b>, {
      position: "top-center",
      color: "red"
    });
  }

  updatePreEscMsgReactApi(props, e) {
    this.state.data[props.index].message = document.getElementById("message" + props.index).innerText.trim();
    this.state.data[props.index].autoTranslate = document.getElementById("autoTranslate" + props.index).checked;

    var validateResult = this.validateCells(props.original.message, props.original.language,
      props.original.autoTranslate);
    if (validateResult == true) {
      var addedData = {
        message: this.state.data[props.index].message,
        language: document.getElementById('selectTriggerlanguage').value,
        autoTranslate: this.state.data[props.index].autoTranslate,

      };
      var updatedData = {
        message: this.state.data[props.index].message,
        autoTranslate: this.state.data[props.index].autoTranslate,
        language: this.state.data[props.index].language,
        id: this.state.data[props.index].id,
        projectId: localStorage.getItem("currentProjectId"),
      };
      var updatedDataController = this
      $.ajax({
        url: "/api/pre-escalation-msg",
        async: false,
        method: 'PATCH',
        headers: {
          'Authorization': "Bearer " + localStorage.getItem("access_token"),
          'Content-Type': 'application/json',
        },
        data: JSON.stringify(updatedData),
        processData: false,
        contentType: "application/json; charset=UTF-8",
        success: function (res) {
          if (res.success === true) {
            updatedDataController.state.editedId = "-1";
            updatedDataController.notifyUpdate();
            updatedDataController.fetchPreEscMsgDataApi();
            updatedDataController.state.disabled = false;
          } else {
            updatedDataController.notifyFailToUpdate(res.result);
            updatedDataController.state.disabled = false;
          }
        },

        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "/";
          }
        }
      })
    }
  }

  notifyUpdate() {
    toast.dismiss();
    toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;PreEscalation Updated Successfully</b>, {
      position: "top-center",

    });
  }
  notifyFailToUpdate(response) {
    toast.dismiss();
    toast(<b>{response}</b>, {
      position: "top-center",
      color: "red"
    });
  }

  makeCelledit(props, e) {
    this.markAsBeingEdited(this.state.data[props.index].id);
  }

  markAsBeingEdited(id) {
    this.state.editedId = id;
    var stateObj = this.state;
    this.setState(stateObj);
  }

  deletePreEscMsgApi = (id) => {
    let deleteRowViewController = this.state.data;
    let deleteApiViewController = this;
    var deleteConstructorVariables = this;

    if (id == "") {
      deleteApiViewController.setState({ deleteRow: true });
      deleteConstructorVariables.setState({ hideDeletePopup: false });
      deleteRowViewController.splice(id, 1);
      deleteApiViewController.fetchPreEscMsgDataApi();
      deleteApiViewController.notifyMsgDeleteSuccess();
      deleteApiViewController.state.disabled = false;
    }
    $.ajax({
      url: "/api/pre-escalation-msg/" + id,
      async: false,
      method: 'DELETE',
      headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
      success: function (res) {

        if (res.success === true) {

          deleteApiViewController.setState({ deleteRow: true });
          deleteConstructorVariables.setState({ hideDeletePopup: false });
          deleteRowViewController.splice(id, 1);
          deleteApiViewController.fetchPreEscMsgDataApi();
          deleteApiViewController.notifyMsgDeleteSuccess();
          deleteApiViewController.state.disabled = false;

        } else {
          deleteApiViewController.notifyFailToDelete(res.result);
          deleteApiViewController.state.disabled = false;
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/";
        }
      }
    });

  }

  notifyMsgDeleteSuccess() {
    toast.dismiss();
    toast(<b>
      <img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />
      &nbsp;&nbsp;Missed-Query Responses Deleted Successfully</b>, {
      position: "top-center"
    });
  }
  notifyFailToDelete(response) {
    toast.dismiss();
    toast(<b>{response}</b>, {
      position: "top-center",
      color: "red"
    });
  }

  componentDidMount() {
    setTimeout(() => {
      this.fetchLanguagesApi();
      this.fetchPreEscMsgDataApi();
    }, 300);

    var thisController = this;
    document.addEventListener("projectChanged", function (event) {
      thisController.state.disabled = false;
      thisController.projectId = event.projectId;
      thisController.fetchLanguagesApi(event.projectId);
      thisController.fetchPreEscMsgDataApi(event.projectId);
    });
  }

  validateCells(message) {
    if ((message == "")) {
      this.notifyMsgFieldEmpty();
      return false;
    }
    else {
      return true;
    }

  }

  notifyMsgFieldEmpty() {
    toast.dismiss();
    toast(<b><img src="assets/images/warn.svg"
      style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
      &nbsp;&nbsp;Please fill all the fields</b>, {
      position: "top-center"
    });

  }

  refreshData = (id) => {
    var refreshContent = this
    refreshContent = this.state.editedId = id;
    this.fetchPreEscMsgDataApi()
    this.setState({ disabled: false })

  }

  notifyFailToLoadLanguages() {
    toast.dismiss();
    toast(<b style={{ color: "red" }}>Oops! Error occurred loading languages.Please try again</b>, {
      position: "top-center",
      color: "red"
    });
  }
  fetchLanguagesApi = (projectId) => {
    if (!projectId) {
      projectId = this.projectId;
      if (!projectId) {
        projectId = localStorage.getItem('currentProjectId');
      }
    }
    var languageController = this;
    $.ajax(
      {
        url: "/api/project-languages-selected",
        async: false,
        method: 'GET',
        data: {
          'projectId': projectId,
        },
        headers: {
          'Authorization': "Bearer " + localStorage.getItem("access_token"),
          'Content-Type': 'application/json'
        },
        success: function (res) {
          if (res.success === true) {
            var loadlanguage = res.result;
            languageController.setState({ language: loadlanguage });
            var numberOfLanguages = loadlanguage.length;
            var ele3 = document.getElementById("selectTriggerlanguage");
            if (ele3 != null) {
              ele3.innerHTML = null
              for (var i = 0; i < numberOfLanguages; i++) {
                ele3.innerHTML = ele3.innerHTML + '<option value="' + loadlanguage[i]['code'] +
                  '">' + loadlanguage[i]['name'] + '</option>';
              }
            }
          }
          else {
            languageController.notifyFailToLoadLanguages();
          }
        }
      }
    )
  }

  fetchPreEscMsgDataApi = (projectId) => {
    if (!projectId) {
      projectId = this.projectId;
      if (!projectId) {
        projectId = localStorage.getItem('currentProjectId');
      }
    }
    var preEscalationMsgController = this;
    var selectedLang;
    if (document.getElementById('selectTriggerlanguage') != null) {
      selectedLang = document.getElementById('selectTriggerlanguage').value;
    }
    $.ajax({
      url: "/api/pre-escalation-msg",
      async: false,
      method: 'GET',
      data: {
        projectId: projectId,
        language: selectedLang,
      },
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("access_token"),
        "Content-Type": "application/json",
      },

      success: function (res) {
        if (res.success === true) {
          var messages = res.result;

          preEscalationMsgController.setState({
            data: messages,
            disabled: false,
            preEscData: messages,
          })
        }
        else {
          preEscalationMsgController.notifyFailToLoadData(res.result)
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/";
        }
      }
    });
  }

  notifyFailToLoadData(response) {
    toast.dismiss();
    toast(<b>{response}</b>, {
      position: "top-center",
      color: "red"
    });
  }
  handleLangChange = (e) => {
    this.state.disabled = false
    this.fetchPreEscMsgDataApi();
  }
  onPageChange = (e) => {
    this.setState({ pageNum: e })
  }

  render() {
    const { data } = this.state
    this.columns = [

      {
        Header: 'Id',
        accessor: 'id',
        show: false,
        Cell: props => (
          <div name="id" id={"id" + props.index}>{props.original.id}
          </div>)
      },

      
      {
        Header: <b> Message</b>,
        accessor: 'message',
        sortable: false,
        Cell: props => (
          <div name="message" className="textarea"
            type="text"
            style={{ height: '4em', background: 'white', resize: 'none', borderBottom: 'none', border: (props.original.id == this.state.editedId || props.original.id == "") ? '1px solid #D2D4DC' : 'none', borderRadius: (props.original.id == this.state.editedId || props.original.id == "") ? '2px' : 'none', paddingLeft: '2px' }}
            id={"message" + props.index}

            rows="1"
            maxLength="250"
            contentEditable={!((props.original.id == "") ? false :
              props.original.id != this.state.editedId) ? "plaintext-only" : false}
            suppressContentEditableWarning>{props.original.message}</div>)
      },

      {
        Header: <b>Auto Translate</b>,
        accessor: 'autoTranslate',
        sortable: false,
        width: 110,
        Cell: props => {
          return (
            <div style={{ textAlign: 'center' }}>
              <label class="switch">
                <input type="checkbox" id={"autoTranslate" + props.index}
                  defaultChecked={props.original.autoTranslate}
                  disabled={(props.original.id == "") ? false : props.original.id != this.state.editedId} />
                <span class="slider round"></span>
              </label>
            </div>
          )
        },

      }, {
        Header: <b>Action</b>,
        accessor: 'action',
        sortable: false,
        width: 100,
        Cell: props => (
          <div id="action">
            {/* edit button */}
            <button style={{
              backgroundColor: "#ffffff", border: "none",
              marginTop: '-13px'
            }}>
              <img className="img-responsive"
                style={{ marginTop: '8px', backgroundColor: '#282a65', borderRadius: '5px', padding: '1px' }}
                title={(props.original.id == "") ||
                  (this.state.data[props.index].id == this.state.editedId) ? 'Save' : 'Edit'}
                src={(props.original.id == "")
                  ?
                  this.saveImageSrc : ((props.original.id != this.state.editedId)
                    ? this.editImageSrc : this.saveImageSrc)}
                onClick={(e) => {
                  (props.original.id == "") ? this.savePreEscalationMsgApi(props, e) : (props.original.id == this.state.editedId) ? this.updatePreEscMsgReactApi(props, e) : this.makeCelledit(props, e);
                }} />
            </button>
            <button style={{
              backgroundColor: "#ffffff",
              border: "none",
              marginTop: '-9px', marginLeft: '-6px'
            }} title="Delete">
              <img className="img-responsive"
                style={{
                  marginTop: '6px',

                  backgroundColor: '#282a65', borderRadius: '5px', padding: '1px'
                }}
                src={"./assets/images/baseline_delete_white_24dp.png"}
                onClick={() => (props.original.id) === '' ?
                  this.fetchPreEscMsgDataApi() :
                  this.setState({
                    hideDeletePopup: true, deletePropIndex: props.index,
                    propsId: props.original.id
                  })
                } />
            </button>
          </div>
        ),
      },
    ]
    return (
      <div style={{ background: "#F9F9FB" }}>
        {/* for toaster */}
        <link rel="stylesheet" href="assets/css/ReactToastify.css" />


        {/* for reactTable */}

        <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />

        {/*for dialog component */}
        <link href="assets/css/ej2-base.css" rel="stylesheet" />
        <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
        <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
        <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
        <link href="assets/css/screenResolution.css" rel="stylesheet" />
        <link rel="stylesheet" href="assets/css/toggleButton.css" />

        <div className="wrapper">
          <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
          <title> Dheeyantra | BackEnd Api </title>
          {/* IonIcons */}
          <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
          {/* Theme style */}
          <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
          <link rel="stylesheet" href="plugins/select2/select2.min.css" />
          <div className="container-fluid">
            < ToastContainer className="Toast-at-center" />
            <div className="row">
              <div className="col-sm-5">
                <h6 className="nav-item" style={{ color: '#282a65', marginTop: '20px' }}>Missed-Query Responses</h6>
              </div>

              <div className="col-sm-7" Align="right">
                <select className="input-group mb-3 form-control select2 "
                  style={{
                    display: 'inline-block',
                    width: '40%', marginRight: '3%'
                  }}

                  tabIndex={-1} aria-hidden="true"
                  name="selectTriggerlanguage" id="selectTriggerlanguage"
                  onChange={this.handleLangChange}>
                </select>
                <button className="btn action-button"
                  title="Add"
                  id="addMsg"
                  onClick={this.state.disabled ? this.notifyMsgFieldEmpty : this.addRow}>
                  <img src="assets/images/add_white_24dp.png" />
                </button>
                <button onClick={this.refreshData} type="button" title="Refresh" className="btn action-button">
                  <img src="./assets/images/refresh_white_24dp.png"></img></button>
              </div>
              <div className="col-lg-12 ">

                <div className="card">

                  <div >
                    <ReactTable id='reactTable'
                      data={data}
                      columns={this.columns}
                      defaultPageSize={10}
                      pageSizeOptions={[5, 10, 15]}
                      onPageChange={this.onPageChange}
                      page={this.state.pageNum}
                    />

                    {/*Dialog Component For Deletion Confirmation*/}
                    <DialogComponent width='400px' animationSettings={this.settings}
                      header='PreEscalation Message' showCloseIcon={true} buttons={this.buttons}
                      ref={dialog => this.dialogInstance = dialog}
                      visible={this.state.hideDeletePopup} close={this.dialogClose}>
                      <img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
                        content="" />&nbsp;Do you want to delete the Missed-Query Responses?
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Note: Press 'Yes' to delete or press 'No' to decline.</DialogComponent>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }


}

export default PreEscalationMsgReact


// WEBPACK FOOTER //
// ./src/projectmgmt/settings/PreEscalationMsgReact.js